/** Site motion variants — classic easing only */
import {
  EASE,
  fadeUp,
  fadeLeft,
  fadeRight,
  scaleIn,
  staggerContainer,
  navItem,
  mobLink,
  mobStagger,
  pageEnter,
  overlayFade,
  navEnter,
  cardTiltSpring,
  cardEntrance,
} from './variants.classic';

export {
  EASE,
  fadeUp,
  fadeLeft,
  fadeRight,
  scaleIn,
  staggerContainer,
  navItem,
  mobLink,
  mobStagger,
  pageEnter,
  overlayFade,
  navEnter,
  cardTiltSpring,
  cardEntrance,
};

export function getEASE() {
  return EASE;
}

export function getPageEnter() {
  return pageEnter;
}

export function getOverlayFade() {
  return overlayFade;
}

export function getNavEnter() {
  return navEnter;
}

export function getCardTiltSpring() {
  return cardTiltSpring;
}
